"use client";

import React from "react";
import Link from "next/link";
import { siteConfig } from "@/config/site.config";

export const CirculoHomeTeaser: React.FC = () => {
  return (
    <section className="relative py-24 md:py-32 px-6 md:px-12 bg-bg-main border-t border-gold/10 overflow-hidden">
      <div className="absolute top-1/3 right-10 w-96 h-96 bg-gold/5 blur-3xl rounded-full pointer-events-none" />

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="text-center flex flex-col items-center mb-16">
          <div className="inline-flex items-center gap-2 border border-gold/30 bg-gold/5 px-3 py-1 rounded-full mb-4">
            <span className="w-2 h-2 rounded-full bg-gold animate-pulse" />
            <span className="text-[10px] font-mono tracking-widest text-gold uppercase">
              {siteConfig.circulo.estado}
            </span>
          </div>

          <h2 className="font-serif text-3xl sm:text-5xl text-text-pure tracking-wide font-light">
            Círculo de <span className="font-playfair italic text-gold">Estudio Copleston</span>
          </h2>
          <div className="w-12 h-[1px] bg-gold/50 mt-6 mb-6" />
          <p className="text-text-muted text-sm sm:text-base font-light max-w-2xl leading-relaxed">
            Leemos, discutimos y pensamos juntos. Gratuito, presencial en Cusco y con conexión sincrónica virtual.
          </p>
        </div>

        {/* Los 3 Pasos */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-14">
          <div className="p-8 rounded-xl border border-gold/15 bg-bg-secondary/30 hover:border-gold/35 transition-all text-left">
            <div className="w-10 h-10 rounded-full border border-gold/30 bg-gold/5 flex items-center justify-center text-gold font-serif text-sm mb-6">
              1
            </div>
            <h3 className="font-serif text-xl text-text-pure font-light mb-3">Lectura Previa</h3>
            <p className="text-text-muted text-xs leading-relaxed font-light">
              Leemos un texto o capítulo seleccionado antes de cada sesión, compartiendo guías orientativas y contexto histórico.
            </p>
          </div>

          <div className="p-8 rounded-xl border border-gold/15 bg-bg-secondary/30 hover:border-gold/35 transition-all text-left">
            <div className="w-10 h-10 rounded-full border border-gold/30 bg-gold/5 flex items-center justify-center text-gold font-serif text-sm mb-6">
              2
            </div>
            <h3 className="font-serif text-xl text-text-pure font-light mb-3">Exposición de 15 min</h3>
            <p className="text-text-muted text-xs leading-relaxed font-light">
              Un miembro presenta las tesis nucleares del autor, sus argumentos y los posibles puntos ciegos o contradicciones.
            </p>
          </div>

          <div className="p-8 rounded-xl border border-gold/15 bg-bg-secondary/30 hover:border-gold/35 transition-all text-left">
            <div className="w-10 h-10 rounded-full border border-gold/30 bg-gold/5 flex items-center justify-center text-gold font-serif text-sm mb-6">
              3
            </div>
            <h3 className="font-serif text-xl text-text-pure font-light mb-3">Debate con Rigor</h3>
            <p className="text-text-muted text-xs leading-relaxed font-light">
              Abrimos el diálogo dialéctico: analizamos objeciones, contrastamos lecturas y cultivamos la honestidad intelectual.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link
            href="/circulo"
            className="inline-flex items-center justify-center gap-2 bg-gold text-bg-main px-9 py-3.5 font-sans font-semibold text-xs uppercase tracking-widest shadow-lg shadow-gold/20 hover:bg-gold-light hover:-translate-y-0.5 transition-all duration-300 rounded"
          >
            Quiero Unirme al Círculo
            <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
};
